module.exports = __webpack_public_path__ + "static/media/favorite-scheduler-white.1eefec5b.svg";